import {
  CalendarDays,
  ClipboardList,
  Receipt,
  LayoutDashboard,
  UserRound,
  Users,
  type LucideIcon,
} from 'lucide-react';

/*
 * The employee portal's navigation, as data — the same shape as `admin-nav.ts`
 * and `client-nav.ts`, reusing that file's `isNavItemActive` rather than growing
 * a third matcher. P4 is one prefix-matching bug and it does not need three
 * homes.
 *
 * **A sidebar, not a bottom tab bar**, and that is the one structural decision
 * of this phase. My original plan assumed bottom tabs because this is the
 * phone-first portal; inspecting the real prototype showed it uses the same
 * sidebar as the other two and reflows correctly at 375px (FINDINGS.md §11.1).
 * A second navigation model for one role is maintenance for no gain. What the
 * employee portal actually needed was not a different shell but correctly sized
 * controls — the prototype fails 44×44 at every point measured (P23, P24).
 *
 * The five destinations are the prototype's, in its order.
 */

export interface EmployeeNavItem {
  readonly label: string;
  readonly to: string;
  readonly icon: LucideIcon;
}

export const EMPLOYEE_NAV: readonly EmployeeNavItem[] = [
  { label: 'Dashboard', to: '/employee', icon: LayoutDashboard },
  { label: 'My Jobs', to: '/employee/jobs', icon: ClipboardList },
  { label: 'My Schedule', to: '/employee/schedule', icon: CalendarDays },
  { label: 'Clients', to: '/employee/clients', icon: Users },
  // Phase 10.1. Sixth destination, after the prototype's five — it has no
  // equivalent, because the prototype has no way for a cleaner to submit one.
  { label: 'My Expenses', to: '/employee/expenses', icon: Receipt },
  { label: 'My Profile', to: '/employee/profile', icon: UserRound },
];
